import React, { useEffect, useState } from "react";
import Button from "../../AdminDashboard/Button";
import {
  Box,
  Grid,
  Paper,
  Typography,
  Card,
  CardContent,
  Divider,
  Collapse,
  // Button,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import useStyles from "./style";
import Select from "react-select";
import { Country, State } from "country-state-city";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import CustomTooltip from "../../../../CohortParticular/tooltip";
import { useHistory, useParams } from "react-router-dom";
import ChatBoxModal from "../../../../common/chatBoxModal";
import api from "../../../../common/dependencies/utils/Api";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import LineWithDot from "../../../../../assets/images/Line wit Dot.svg";
import privateCohortBtn from "../../../../../assets/svg/shield2.svg";
import copyButton from "../../../../../assets/svg/copyLink.svg";
import moment from "moment";
import Modal from "../../StartupDashboard/MyRequests/Modal/modal";
import ModalFilters from "../../../../common/modalFilters";
import clsx from "clsx";
import ModalFilter2 from "../../../../common/modalFilter2";
import shareRounded from "../../../../AdminModule/Dashboard/MentorDashboard/MentorHome/img/share-round.svg";
import {
  COHORT_PARTICULAR,
  VIEW_STARTUP_APPLICATION_DATA,
  GET_MENTOR_MODULE_COHORT_STATUS,
  GET_MENTOR_MODULE_COHORT_LIST,
} from "../../../../common/constants/ApplicationUrl";
import * as CryptoJS from "crypto-js";
import { PROFILE_KEY } from "../../../../common/constants/actionConstants";
import {
  getAdminMentorApplicationList,
  getPredefineOptionsList,
} from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import { postMentorModuleCohort,postCohortMentorListCounter } from "../dependencies/action";
import Pagination from "react-js-pagination";
import swal from "sweetalert";

const MentorPage = (props) => {
  const {
    getAdminMentorApplicationList,
    getPredefineOptions,
    postMentorModuleCohort,
    getTotalMentorsData,
    getTotalMentorsPaginate,
    commonCohortId,
    parentData,
    setCommonCohortId,
    postCohortMentorListCounter,
    mentorCounter,
  } = props;
  class AesUtil {
    constructor(keySize, iterationCount) {
      this.keySize = keySize / 32;
      this.iterationCount = iterationCount;
    }

    generateKey = function (salt, passPhrase) {
      let key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
        keySize: this.keySize,
        iterations: this.iterationCount,
      });
      return key;
    };

    encrypt = function (salt, iv, passPhrase, plainText) {
      let key = this.generateKey(salt, passPhrase);
      let encrypted = CryptoJS.AES.encrypt(plainText, key, {
        iv: CryptoJS.enc.Hex.parse(iv),
      });
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    };
  }
  const newCountryArray = [];
  const newStateArray = [];
  const defaultFormData = {
    search: "",
    industry: null,
    specialization: null,
    stage: null,
    recognized: "",
    state: "",
    country: "",
  };
  const customStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "white",
      minWidth: "15.75rem",
      maxWidth: "220px",
      // color: "#333",
      color: "rgb(121, 193, 206)",
      whiteSpace: "nowrap",
      fontSize: "16px",
      position: "relative",
    }),
    menu: (base) => ({
      ...base,
      width: "max-content",
      // minWidth: "100%",
      fontSize: "14px",
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isSelected
          ? "#b499c7"
          : isFocused
          ? "#e4d7ee"
          : "white",
        color: isSelected ? "white" : "black",
        cursor: isDisabled ? "not-allowed" : "default",
        whiteSpace: "nowrap",
        textAlign: "left",
      };
    },
  };
  const [intentData, setIntentData] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpen2, setModalOpen2] = useState(false);
  const [modalData, setModalData] = useState();
  const [filterNameValue, setFilterNameValue] = useState("");
  const [filterName, setFilterName] = useState("");
  const [newCountrySelect, setNewCountrySelect] = useState(false);
  const [nameListValue, setNameListValue] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [formData, setFormData] = useState(defaultFormData);
  const [data, setData] = useState();
  const [chatBoxModalOpen, setChatBoxModalOpen] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [filterIndustry, setFilterIndustry] = useState("");
  const [filterFunction, setFilterFunction] = useState("");
  const [filterStage, setFilterStage] = useState("");
  const [filterState, setFilterState] = useState("");
  const [filterCountry, setFilterCountry] = useState("");
  const [newCountryOptions, setNewCountryOptions] = useState(newCountryArray);
  const [newStateOptions, setNewStateOptions] = useState(newStateArray);
  const [toggleText, setToggleText] = useState(false);
  const [iconsCollapse, setIconsCollapse] = useState(false);
  const [datavaribale, setdatavaribale] = useState("pending");
  const [modalVisibility, setModalVisibility] = useState(false);
  const [loginData, setLoginData] = useState();
  const [isParentData, setIsParentData] = useState("");
  const [viewApplicationData, setViewApplicationData] = useState("");
  let presentTime = moment(new Date()).format("DD-MM-YYYY");
  let currentMonth = moment().format("MM");
  const [sessionDate, setSessionDate] = useState("");
  const [sessionMonth, setSessionMonth] = useState("");
  const [modalVisibility2, setModalVisibility2] = useState();
  const [cohortAdminBoolean, setCohortAdminBoolean] = useState(false);
  const [activeText0, setActiveText0] = useState(false);
  const [activeText2, setActiveText2] = useState(false);
  const [activeText3, setActiveText3] = useState(false);
  const [activeText4, setActiveText4] = useState(false);
  const [mentorID, setMentorID] = useState("");
  let presentUrl = window.location.href;
  // let sessionDate = moment(ternaryValue).format("DD-MM-YYYY");
  const LoginRole =
    localStorage.getItem("SavedLoggedInData") &&
    JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role;
  const LoginRole2 =
    localStorage.getItem("SavedLoggedInData") &&
    JSON.parse(localStorage.getItem("SavedLoggedInData"));
  const value =
    localStorage.getItem("SavedLoggedInData") &&
    JSON.parse(localStorage.getItem("SavedLoggedInData"));
  const classes = useStyles();
  const history = useHistory();
  const clickedOnBack = () => {
    history.goBack();
  };
  const params = useParams();
  useEffect(() => {
    const LoginRole =
      localStorage.getItem("SavedLoggedInData") &&
      JSON.parse(localStorage.getItem("SavedLoggedInData"));
    setLoginData(LoginRole);
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    let paramData;
    const LoginRole =
      localStorage.getItem("SavedLoggedInData") &&
      JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role;
    let testID;
    if (
      commonCohortId !== undefined &&
      commonCohortId !== null &&
      commonCohortId !== ""
    ) {
      testID = commonCohortId;
    } else {
      testID = params.cohortId;
    }
    if (LoginRole === "Mentor" || LoginRole === "Admin") {
      paramData = {
        id: testID,
        mentorId: JSON.parse(localStorage.getItem("SavedLoggedInData"))?.id,
      };
    } else if (LoginRole === "Startup") {
      paramData = {
        id: testID,
        startupId: JSON.parse(localStorage.getItem("SavedLoggedInData"))?.id,
      };
    } else {
      paramData = {
        id: testID,
      };
    }
    // axios({
    //   url: COHORT_PARTICULAR,
    //   method: "post",
    //   data: paramData,
    // })
    api
      .POST(COHORT_PARTICULAR, paramData)
      .then((res) => {
        // console.log("COHORT_PARTICULAR res",res,"param",paramData)
        setData(res.data?.data);
        setSessionDate(
          moment(res?.data?.data?.cohort_date).format("DD-MM-YYYY")
        );
        setSessionMonth(moment(res?.data?.data?.cohort_date).format("MM"));
      })
      .catch((err) => {});
  }, [datavaribale]);

  useEffect(() => {
    // const params = { id: props.location.state };

    api
      .POST(`${VIEW_STARTUP_APPLICATION_DATA}`, { id: value?.dippNumber })
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          if (response.data.data) setViewApplicationData(response.data.data);
        } else {
        }
      })
      .catch((e) => {});
      setActiveText0(true);
  }, []);
  useEffect(() => {
    const indDefaultObject = {
      value: "select",
      label: "Select Country",
    };

    const indDefaultObject2 = {
      value: "select",
      label: "Select State",
    };

    Country.getAllCountries().map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newCountryArray.push(newObject);

      setNewCountryOptions(newCountryArray);
    });

    newCountryArray.unshift(indDefaultObject);

    State.getStatesOfCountry(newCountrySelect === true ? "IN" : null).map(
      (item) => {
        const newObject = {
          value: item.name,
          label: item.name,
        };

        newStateArray.push(newObject);

        setNewStateOptions(newStateArray);
      }
    );

    newStateArray.unshift(indDefaultObject2);
  }, [newCountrySelect]);
  // useEffect(() => {
  // console.log("viewApplicationData",viewApplicationData)
  // }, [viewApplicationData])
  useEffect(() => {
    if (toggleText) {
      setTimeout(() => {
        setToggleText(false);
      }, 80000);
    }
  }, [toggleText]);
  const ViewProfile = (item, id) => {
    const currentRoute = window.location.href;
    let sample;
    sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
    let reRoute = window.open(
      `/mentor-profile/${encryptAES2(item, PROFILE_KEY)}`,
      "_blank"
    );
    // let reRoute = window.open(sample + `/mentor-profile/${item}`, "_blank");
    // reRoute.id = item;
    //
    // history.push({
    //   pathname: `/mentor-profile/${item.email}`,
    //   state: { prevPage: "mentorPage",data:item },
    // });
  };
  const encryptAES2 = (text, key) => {
    // let iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    // let salt = CryptoJS.lib.WordArray.random(128 / 8).toString(
    //   CryptoJS.enc.Hex
    // );

    // let aesUtil = new AesUtil(128, 1000);
    // let ciphertext = aesUtil.encrypt(salt, iv, key, text);

    // let aesText = iv + "::" + salt + "::" + ciphertext;

    return btoa(text);
  };
  const getMentorApplicationsName = (name) => {
    let params = {
      sortKey: "name",
      sortOrder: "ASC",
      country: filterCountry
        ? filterCountry == "Select Country"
          ? ""
          : filterCountry
        : null,
      state: filterState ? (filterState == "select" ? "" : filterState) : null, // optional
      industry: filterIndustry
        ? filterIndustry == "select"
          ? ""
          : filterIndustry
        : null, // optional
      function: filterFunction
        ? filterFunction == "select"
          ? ""
          : filterFunction
        : null, // optional
      stage: filterStage ? (filterStage == "select" ? "" : filterStage) : null, // optional
      // status: status,
      searchField: name === "Select" ? "" : name,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
      status: selectedStatus !== "" ? selectedStatus : "",
    };
    getAdminMentorApplicationList(params);
  };
  const getMentorApplications = (status) => {
    setActivePage(1);
    let params = {
      sortKey: "name",
      sortOrder: "ASC",
      country: filterCountry
        ? filterCountry == "Select Country"
          ? ""
          : filterCountry
        : null,
      state: filterState ? (filterState == "select" ? "" : filterState) : null, // optional
      industry: filterIndustry
        ? filterIndustry == "select"
          ? ""
          : filterIndustry
        : null, // optional
      function: filterFunction
        ? filterFunction == "select"
          ? ""
          : filterFunction
        : null, // optional
      stage: filterStage ? (filterStage == "select" ? "" : filterStage) : null, // optional
      status: status,
      searchField: filterNameValue == "Select" ? "" : filterNameValue,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
    };
    getAdminMentorApplicationList(params);
  };
  const paramsIncoming = useParams();
  useEffect(() => {
    if (data !== undefined && data !== null && data !== "") {
      // console.log("cohortAdminBoolean effect",data?.cohort?.cohortAdminId == value?.id)
      if (data?.cohort?.cohortAdminId == value?.id) setCohortAdminBoolean(true);
      else setCohortAdminBoolean(false);
      getCohortMentorFunction(
        data?.cohort?.cohortAdminId == value?.id ? "" : "Accepted",
        0
      );
    }
  }, [data]);

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    getCohortMentorFunction(
      cohortAdminBoolean ? selectedStatus : "Accepted",
      pageNumber - 1
    );
  };

  const getCohortMentorFunction = (status, pageNumber) => {
    let params = {
      cohortAdminId: data?.cohort?.cohortAdminId,
      industry:
        filterIndustry && filterIndustry == "select" ? "" : filterIndustry,
      function:
        filterFunction && filterFunction == "select" ? "" : filterFunction,
      stage: filterStage && filterStage == "select" ? "" : filterStage,
      cohortId: data?.cohortId,
      pageFilter: {
        currentPage:
          pageNumber !== undefined && pageNumber !== null && pageNumber !== ""
            ? pageNumber
            : 0,
        includeCount: true,
        pageSize: 12,
        sortField: "id",
        sortOrder: "ASC",
      },
      searchField:
        filterName !== undefined && filterName !== null && filterName !== ""
          ? filterName
          : "",
      searchKey: "",
      requestStatus: status,
    };
    postMentorModuleCohort(params);
  };
  useEffect(() => {
    if (
      getTotalMentorsData !== undefined &&
      getTotalMentorsData !== null &&
      getTotalMentorsData?.length > 0
    )
      getTotalMentorsData?.forEach((element, index) => {
        if (index === 0) {
          let arr2 = {
            value: "Select",
            label: "Select Mentor",
          };
          setNameListValue((oldArray) => [...oldArray, arr2]);
        }
        let arr = {
          value: element?.mentor?.id,
          label: element?.mentor?.applicant_name,
        };
        if (getTotalMentorsData.length >= nameListValue.length)
          setNameListValue((oldArray) => [...oldArray, arr]);
      });
  }, [getTotalMentorsData]);
  const returnTextStatus = (status) => {
    if (status == "Ongoing Mentorship") {
      return "Message";
    } else if (status == "Declined") {
      return "Declined";
    } else if (status == null) {
      return "Send Request";
    } else if (status == "Received Request") {
      return "Sent";
    }
  };
  const updateMentorStatus = (params) => {
    api
      .POST(`${GET_MENTOR_MODULE_COHORT_STATUS}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          if (data?.success == false) {
            swal({
              title: "Warning",
              text: `Mentor Request ` + params?.requestStatus + ` Not Sent!! `,
              icon: "info",
            });
          } else {
            swal({
              title: "Sucess",
              text:
                `Mentor Application ` +
                params?.requestStatus +
                ` Successfully!! `,
              icon: "success",
              buttons: {
                closemodal: {
                  text: "OK",
                },
              },
            }).then((value) => {
              getCohortMentorFunction("", activePage - 1);
              switch (value) {
                case "closemodal":
                  // console.log(value, "value");

                  break;
                default:
                // console.log("cannot close modal");
              }
            });
            // window.location.reload();
          }
        } else {
          swal({
            title: "WARNING",
            text: `Failed to Update Request `,
            icon: "info",
          });
        }
        getCohortPendingMentorFunction();
      })
      .catch((e) => {
        swal({
          title: "WARNING",
          text: `Failed to Update Request `,
          icon: "info",
        });
        return Promise.reject(e);
      });
  };

  const handleDelete = (item) => {
    swal("Are you sure?", "Do you want to decline this application?", {
      icon: "warning",
      buttons: {
        delete: {
          text: "OK",
        },
        decline: {
          text: "CANCEL",
        },
      },
    })
      .then((value) => {
        if (value === "delete") {
          let params = {
            id: item.id,
            requestStatus: "Declined",
            updatedBy: LoginRole2.id,
          };
          updateMentorStatus(params);
        } else {
          swal("Decline operation cancelled");
        }
      })

      .catch((err) => {});
  };
  useEffect(() => {
    if (isParentData) {
      getCohortMentorFunction(cohortAdminBoolean ? "" : "Accepted", 0);
      setTimeout(() => {
        setIsParentData(false);
      }, 3000);
    }
  }, [isParentData]);
  const getCohortPendingMentorFunction = () => {
    let params = {
      cohortAdminId: data?.cohort?.cohortAdminId,
      industry: "",
      function: "",
      stage: "",
      cohortId: data?.cohortId,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
      searchField: "",
      searchKey: "",
      requestStatus: "Requested",
    };
    api
    .POST(GET_MENTOR_MODULE_COHORT_LIST, params)
    .then((res) => {
      let incomingData= res?.data?.data;
      if(incomingData !== undefined && incomingData !== "" && incomingData !== null && incomingData?.length > 0)
      {
      props?.setMentorMarker(true);
      }
      else{
        props?.setMentorMarker(false);
      }
     
    })
    .catch((err) => {});
  };
  useEffect(() => {
    postCohortMentorListCounter({
      cohortId:params.cohortId
    })
  }, [])
  
  return (
    <Box className={classes.rootMentorPage}
   
    //  style={{marginTop:"8rem"}}
     >
      <ModalFilters
        // cohortId={""}
        sendToParent={setIsParentData}
        modalVisibility={modalVisibility}
        setModalVisibility={setModalVisibility}
        fromModule="allMentorsList2"
        viewApplicationData={viewApplicationData}
        mentorID={mentorID}
      />
      {modalOpen && (
        <Modal
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          modalData={modalData}
          intentToMentor={intentData}
          hideData={true}
        />
      )}
      {
        modalOpen2 &&
        <Modal
        modalOpen={modalOpen2}
        setModalOpen={setModalOpen2}
        modalData={modalData}
      />
      }
     
      {chatBoxModalOpen ? (
        <ChatBoxModal
          modalVisibility={chatBoxModalOpen}
          setModalVisibility={setChatBoxModalOpen}
          receiverInfo={mentorID}
          receiverId={mentorID.id}
        />
      ) : (
        ""
      )}
      {cohortAdminBoolean && (
        <div
          className="admin-bottom-cardNew row mobileviewmentorbelow"
          style={{ padding: "20px" }}
        >
          <div className="row ">
            <div
              className="d-flex justify-content-between align-items-center groupsessionheaderdesktop"
              // style={{ position: "relative", left: "-2rem" }}
            >
              <div
                className="resourcesCohortStatus newuserTooltip"
                style={{ position: "relative", left: "0rem" }}
              >
                <p
                  onClick={() => {
                    setActiveText0(true);
                    setActiveText2(false);
                    setActiveText3(false);
                    setActiveText4(false);
                    getCohortMentorFunction("", 0);
                    setSelectedStatus("");
                    setActivePage(1);
                  }}
                  style={{
                    color: activeText0 ? "#277acc" : "#838186",
                    fontSize: "18px",
                    left: "0",
                  }}
                  className=""
                >
                  ALL : {mentorCounter && mentorCounter?.total}
                </p>

                <span className="tooltiptext   tooltip-bottom group-01">
                  Click to View All Mentors
                </span>

                {activeText0 ? (
                  <img
                    className="requestStatusBar statusBarLine00"
                    src={LineWithDot}
                    style={{
                      width: "6.8vw",
                      left: "-0.9rem",
                      position: "relative",
                    }}
                  />
                ) : (
                  ""
                )}
              </div>

              <div
                className="resourcesCohortStatus newuserTooltip"
                style={{ position: "relative", left: "2rem" }}
              >
                <div className="d-flex">
                  <div>
                    <p
                      onClick={() => {
                        setActiveText0(false);
                        setActiveText2(true);
                        setActiveText3(false);
                        setActiveText4(false);
                        setActivePage(1);
                        getCohortMentorFunction("Accepted", 0);
                        setSelectedStatus("Accepted");
                      }}
                      style={{
                        color: activeText2 ? "#277acc" : "#838186",
                        fontSize: "18px",
                      }}
                      className=""
                    >
                      ACCEPTED : {mentorCounter && mentorCounter?.accepted}
                    </p>
                    <span className="tooltiptext   tooltip-bottom group-02">
                      Click to View Accepted Mentors
                    </span>
                  </div>
                </div>

                {activeText2 ? (
                  <img
                    className="requestStatusBar statusBarLine00"
                    src={LineWithDot}
                    style={{
                      width: "11.4vw",
                      left: "0.1rem",
                      position: "relative",
                    }}
                  />
                ) : (
                  ""
                )}
              </div>
              <div
                className="resourcesCohortStatus newuserTooltip"
                style={{ position: "relative", left: "0.75rem" }}
              >
                <div className="d-flex">
                  <div>
                    <p
                      onClick={() => {
                        setActiveText0(false);
                        setActiveText2(false);
                        setActiveText3(true);
                        setActiveText4(false);
                        getCohortMentorFunction("Requested", 0);
                        setSelectedStatus("Requested");

                        //  getTableDataStatus("Requested");
                        setActivePage(1);
                      }}
                      style={{
                        color: activeText3 ? "#277acc" : "#838186",
                        fontSize: "18px",
                      }}
                      className=""
                    >
                      PENDING REQUEST : {mentorCounter && mentorCounter?.requested}
                    </p>

                    <span className="tooltiptext   tooltip-bottom group-03">
                      Click to View Pending Request
                    </span>
                  </div>
                </div>
                {activeText3 ? (
                  <img
                    className="requestStatusBar positionBar000"
                    src={LineWithDot}
                    style={{
                      width: "12.2vw",
                      left: "0.2rem",
                      position: "relative",
                    }}
                  />
                ) : (
                  ""
                )}
              </div>
              <div
                className="resourcesCohortStatus newuserTooltip"
                style={{ position: "relative", left: "0.75rem" }}
              >
                <div className="d-flex">
                  <div>
                    <p
                      onClick={() => {
                        setActiveText0(false);
                        setActiveText2(false);
                        setActiveText3(false);
                        setActiveText4(true);
                        getCohortMentorFunction("Declined", 0);
                        setSelectedStatus("Declined");
                        // getTableDataStatus("Declined");
                        setActivePage(1);
                      }}
                      style={{
                        color: activeText4 ? "#277acc" : "#838186",
                        fontSize: "18px",
                      }}
                      className=""
                    >
                      DECLINED : {mentorCounter && mentorCounter?.declined}
                    </p>

                    <span className="tooltiptext   tooltip-bottom group-03">
                      Click to View Declined Mentors
                    </span>
                  </div>
                </div>
                {activeText4 ? (
                  <img
                    className="requestStatusBar positionBar000"
                    src={LineWithDot}
                    style={{
                      width: "10.2vw",
                      left: "-0.9rem",
                      position: "relative",
                    }}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="filter-row filter-row-common filterDivMentorapp ">
        {/* <div className="container"> */}
        <div>
          <form className="formContainer newfilterdivnow">
            <div className="d-flex col-12 mt-4">
              <div
                className="col-8 d-flex justify-content-between"
                style={{ gap: "10px" }}
              >
                {/* <div className="user-type-dropdown newuserTooltip">
                      <Select
                        required={true}
                        id="searchBy"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="searchBy"
                        className="col-12"
                        styles={customStyles}
                        value={formData.name}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              name: e.name == "select" ? null : e,
                            };
                          });
                          setFilterName(e.name);
                          setFilterNameValue(e.value);
                          getCohortMentorFunctionName(e.value);
                        }}
                        options={nameListValue.length > 0 ? nameListValue : ""}
                        placeholder="Search Mentor"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Mentor
                      </span>
                    </div> */}
                <div className="user-type-dropdown   newuserTooltip">
                  <Select
                    required={true}
                    id="Industry"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    name="industry"
                    className="col-12 gendermentorinput"
                    styles={customStyles}
                    value={formData.industry}
                    onChange={(e) => {
                      setFormData((user) => {
                        return {
                          ...user,
                          industry: e.value == "select" ? null : e,
                        };
                      });
                      setFilterIndustry(e.value);
                    }}
                    options={getPredefineOptions?.industry_options}
                    placeholder="Industry"
                  />
                  <span
                    className="tooltiptext tooltip-bottom"
                    style={{ left: "77px", top: "45px", width: "130px" }}
                  >
                    Search Industry
                  </span>
                </div>
                <div className="user-type-dropdown   newuserTooltip">
                  <Select
                    required={true}
                    id="specialization"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    name="specialization"
                    className="col-12 gendermentorinput"
                    styles={customStyles}
                    value={formData.function}
                    onChange={(e) => {
                      setFormData((user) => {
                        return {
                          ...user,
                          function: e.value == "select" ? null : e,
                        };
                      });
                      setFilterFunction(e.value);
                    }}
                    options={getPredefineOptions?._specialisation}
                    placeholder="Function"
                  />
                  <span
                    className="tooltiptext tooltip-bottom"
                    style={{ left: "77px", top: "45px", width: "130px" }}
                  >
                    Search Function
                  </span>
                </div>

                <div className="user-type-dropdown   newuserTooltip">
                  <Select
                    required={true}
                    id="stage"
                    // label="Gender*"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    name="stage"
                    className="col-12 gendermentorinput"
                    styles={customStyles}
                    value={formData.stage}
                    onChange={(e) => {
                      setFormData((user) => {
                        return {
                          ...user,
                          stage: e.value == "select" ? null : e,
                        };
                      });
                      setFilterStage(e.value);
                    }}
                    options={getPredefineOptions?.stage_of_startup_options}
                    placeholder="Stage"
                  />
                  <span
                    className="tooltiptext tooltip-bottom"
                    style={{ left: "77px", top: "45px", width: "130px" }}
                  >
                    Search Stage
                  </span>
                </div>

                <div className="apply-section newuserTooltip">
                  <Button
                    // onClick={handleClickOfFilter}
                    onClick={() =>
                      getCohortMentorFunction(
                        cohortAdminBoolean ? selectedStatus : "Accepted",
                        activePage - 1
                      )
                    }
                    text="GO"
                    className="btn-container  filter-button top-btn newcoloredbtn"
                  ></Button>
                  <span
                    className="tooltiptext   tooltip-bottom"
                    style={{
                      left: "46px",
                      width: "126px",
                      height: "48px",
                      top: "42px",
                    }}
                  >
                    Click to Apply Filters
                  </span>
                </div>
              </div>

              <div className="col-4 d-flex justify-content-end">
                <div
                  className="dashboard-bottom-btn top-btn  newuserTooltip "
                  onClick={() => {
                    if (loginData?.role == "Mentor") {
                      let reRoute = window.open(
                        `/dashboard/mentorship-mentor/${value?.id}`,
                        "_blank"
                      );
                    } else {
                      window.open(
                        `/startup-dashboard/mentorships/${
                          JSON.parse(localStorage.getItem("SavedLoggedInData"))
                            .id
                        }`,
                        "_blank"
                      );
                    }
                    // reRoute.startupData = item;
                    // reRoute.fromModule = "mentorList";
                  }}
                  style={{
                    marginLeft: "10px",
                    width: "65%",
                    position: "relative",
                    bottom: "0.25rem",
                  }}
                >
                  <p
                    style={{
                      cursor: "pointer",
                      color: "white",
                      position: "relative",
                      top: "-1.5rem",
                      fontSize: "16px",
                    }}
                    className="createcohortsessionbtnpara"
                  >
                    My Mentorships
                  </p>
                  <span
                    className="tooltiptext tooltip-bottom"
                    style={{
                      left: "150px",
                      top: "60px",
                      width: "220px",
                    }}
                  >
                    Click to view my Mentorships
                  </span>
                </div>
              </div>
            </div>

            <div className="row mobileFilterRow">
              <div className="col-11 d-flex justify-content-around mobilefilterunder">
                <div className="user-type-dropdown col-2 select-box">
                  <Select
                    required={true}
                    id="searchBy"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    name="searchBy"
                    className="col-12 gendermentorinput input1menappadmndash"
                    styles={customStyles}
                    value={formData.name}
                    onChange={(e) => {
                      setFormData((user) => {
                        return {
                          ...user,
                          name: e.name == "select" ? null : e,
                        };
                      });
                      setFilterName(e.name);
                      setFilterNameValue(e.value);
                      getMentorApplicationsName(e.value);
                    }}
                    options={nameListValue.length > 0 ? nameListValue : ""}
                    placeholder="Search Mentor"
                  />
                </div>
                <div className="user-type-dropdown col-2 select-box">
                  <Select
                    required={true}
                    id="Industry"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    name="industry"
                    className="col-12 gendermentorinput input1menappadmndash"
                    styles={customStyles}
                    value={formData.industry}
                    onChange={(e) => {
                      setFormData((user) => {
                        return {
                          ...user,
                          industry: e.value == "select" ? null : e,
                        };
                      });
                      setFilterIndustry(e.value);
                    }}
                    options={getPredefineOptions?.industry_options}
                    placeholder="Industry"
                  />
                </div>
                <div className="user-type-dropdown col-2 select-box">
                  <Select
                    required={true}
                    id="specialization"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    name="specialization"
                    className="col-12 gendermentorinput input1menappadmndash"
                    styles={customStyles}
                    value={formData.function}
                    onChange={(e) => {
                      setFormData((user) => {
                        return {
                          ...user,
                          function: e.value == "select" ? null : e,
                        };
                      });
                      setFilterFunction(e.value);
                    }}
                    options={getPredefineOptions?._specialisation}
                    placeholder="Function"
                  />
                </div>

                <div className="user-type-dropdown col-2 select-box">
                  <Select
                    required={true}
                    id="stage"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    name="stage"
                    className="col-12 gendermentorinput input1menappadmndash"
                    styles={customStyles}
                    value={formData.stage}
                    onChange={(e) => {
                      setFormData((user) => {
                        return {
                          ...user,
                          stage: e.value == "select" ? null : e,
                        };
                      });
                      setFilterStage(e.value);
                    }}
                    options={getPredefineOptions?.stage_of_startup_options}
                    placeholder="Stage"
                  />
                </div>
                <div className="user-type-dropdown col-2 select-box">
                  <Select
                    required={true}
                    id="country"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    name="country"
                    className="col-12 gendermentorinput input1menappadmndash"
                    styles={customStyles}
                    value={formData.country}
                    onChange={(e) => {
                      setFormData((user) => {
                        return {
                          ...user,
                          country: e.value == "select" ? null : e,
                        };
                      });

                      setFilterCountry(e.label);

                      if (e.label === "India") {
                        setNewCountrySelect(true);
                      } else {
                        setNewCountrySelect(false);
                      }
                      setNewStateOptions("");
                    }}
                    options={newCountryOptions}
                    placeholder="Country"
                  />
                </div>

                <div className="user-type-dropdown col-2 select-box">
                  <Select
                    required={true}
                    id="state"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    name="state"
                    className="col-12 gendermentorinput input1menappadmndash"
                    styles={customStyles}
                    value={formData.state}
                    onChange={(e) => {
                      setFormData((user) => {
                        return {
                          ...user,
                          state: e.value == "select" ? null : e,
                        };
                      });
                      setFilterState(e.value);
                    }}
                    options={newStateOptions}
                    placeholder="State"
                  />
                </div>
                <div
                  className="col-md-1 apply-section d-flex justify-content-end"
                  style={{ color: "transparent" }}
                >
                  <Button
                    className="green-btn filter-btn"
                    onClick={() => getMentorApplications(selectedStatus)}
                    text="Go"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      {
            parentData?.cohort?.cohortStatus !== undefined && parentData?.cohort?.cohortStatus == "CLOSED" &&
            <div class="d-flex justify-content-end fixedMessageSticky"><div class="fixedMessageStickyText2" style={{fontSize:"1.25rem"}}>This Cohort is Closed</div></div>
          }  
      <div
        className="totalTableCount3"
        style={{ marginTop: "0", marginBottom: "0" }}
      >
        Total Mentors : {getTotalMentorsPaginate?.totalElements} &lt;{" "}
        {getTotalMentorsPaginate?.currentPage} of{" "}
        {getTotalMentorsPaginate?.numPages} &gt;{" "}
      </div>
      <div className="mentorCohortWrapper">
        {getTotalMentorsData !== undefined &&
        getTotalMentorsData !== null &&
        getTotalMentorsData !== "" &&
        getTotalMentorsData?.length > 0 ? (
          getTotalMentorsData.map((item, index) => {
            return (
              <Paper className="mentorCohortBox">
                <div
                  className={
                    (item?.requestStatus == "Requested" &&
                      cohortAdminBoolean) ||
                    (item?.requestStatus == "Declined" && cohortAdminBoolean)
                      ? "headerSectionCardV25"
                      : item?.mentor?.id == loginData?.id ? "headerSectionCardV26" : "headerSectionCardV2"
                  }
                >
                  <div
                    className="newuserTooltip mentorCohortCard"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      ViewProfile(item?.mentor?.email);
                    }}
                  >
                    <img
                      className="cohortMentorInvitedAbout"
                      src={
                        item?.mentor?.image !== undefined &&
                        item?.mentor?.image !== "" &&
                        item?.mentor?.image !== null
                          ? item?.mentor?.image
                          : hashImage
                      }
                    />
                    <span
                      className="tooltiptext tooltip-bottom "
                      style={{
                        left: "9rem",
                        top: "7rem",
                        width: "150px",
                      }}
                    >
                      View Mentor Profile
                    </span>
                  </div>
                  <div className="mentorCohortCard2">
                    <div className="mentorPageHeading">
                      {item?.mentor?.applicant_name}
                    </div>
                    <div>{item?.mentor?.current_designation} </div>
                    <div> {item?.mentor?.organization_name}</div>
                    <div className="mentorContentsAlign  mt-2">
                      {" "}
                      <div style={{ width: "55%" }}>Sector </div>
                      <div
                        className="d-flex flex-wrap"
                        style={{ textAlign: "left", width: "100%" }}
                      >
                        {/* {
                      item?.mentor?.sectors?.length < 3
                    } */}
                        {item?.mentor?.sectors?.length > 0 && item?.mentor?.sectors.map((item2, index2) => {
                          if (index2 < 2)
                            return (
                              <div className="mentorSubListSpace">
                                {item2}
                                {/* {item?.mentor?.sectors?.length - 1 > index2-1 && ", "} */}
                              </div>
                            );
                          // else if(index2 == 2){
                          //   return(
                          //     <div className="tooltipicon sessionListMentorNew" onClick={()=>{ ViewProfile(item?.mentor?.email)}}>
                          //       View More
                          //     </div>
                          //   )
                          // }
                          else {
                          }
                        })}
                      </div>
                    </div>
                    <div className="mentorContentsAlign mt-2">
                      {" "}
                      <div style={{ width: "55%" }}>Function</div>
                      <div
                        className="d-flex flex-wrap"
                        style={{ textAlign: "left", width: "100%" }}
                      >
                        {/* {
                      item?.mentor?.sectors?.length < 3
                    } */}
                        {item?.mentor?.services?.length > 0 && item?.mentor?.services.map((item2, index2) => {
                          if (index2 < 2)
                            return (
                              <div className="mentorSubListSpace">
                                {item2}
                                {/* {item?.mentor?.services?.length  > 2 && ", "} */}
                              </div>
                            );
                          // else if(index2 == 2){
                          //   return(
                          //     <div className="tooltipicon sessionListMentorNew" onClick={()=>{ ViewProfile(item?.mentor?.email)}}>
                          // View More
                          //     </div>
                          //        )
                          //       }
                          else {
                            {
                              /* <span
                            className="tooltiptextCohortV2 mentorSubListSpace"
                            style={{padding:"25px"}}

                          >
                            <h5 style={{ color: "#fff" }}>Services</h5>
                            <div>
                            {item?.mentor?.services.map((item2, index2) => {
                      return (
                        <span className="mentorSubListSpace">
                          {item2}
                          {item?.mentor?.services?.length - 1 > index2 && ", "}
                        </span>
                      )})}</div>
                          </span> */
                            }
                          }
                        })}
                      </div>
                    </div>
                    {/* <div className="mentorContentsAlign"> <div>Services:{" "}</div>
                  <div className="d-flex flex-wrap">
                    {item?.mentor?.services.map((item2, index2) => {
                      return (
                        <span className="mentorSubListSpace">
                          {" "}{item2}
                          {item?.mentor?.services?.length - 1 > index2 && ", "}
                        </span>
                      );
                    })}
                    </div>
                    </div>   */}

                    {item?.mentor?.activeMentorships !== undefined &&
                      item?.mentor?.activeMentorships !== null &&
                      item?.mentor?.activeMentorships !== "" &&
                      item?.mentor?.activeMentorships !== 0 && (
                        <div className="mentorContentsAlign mt-2 ">
                          {" "}
                          <div style={{ width: "55%" }}>
                            Currently Mentoring{" "}
                          </div>
                          <span className="mentorSubListSpace">
                            {item?.mentor?.activeMentorships}
                          </span>
                        </div>
                      )}
                    {/* <div className="mentorContentsAlign">No. of Cohorts Joined:<span className="mentorSubListSpace">5</span></div> */}
                  </div>
                </div>
                {item?.requestStatus == "Requested" && cohortAdminBoolean && (parentData?.cohort?.cohortStatus !== undefined && parentData?.cohort?.cohortStatus !== "CLOSED" ) && (
                  <div
                    className="d-flex footerCohortV26"
                    style={{
                      justifyContent: "center",
                      width: "100%",
                      gap: "7px",
                    }}
                  >
                    <div
                      className="d-flex newAboutExitBtn6 newuserTooltip"
                      onClick={() => {
                        let params = {
                          id: item.id,
                          requestStatus: "Accepted",
                          updatedBy: value.id,
                        };
                        updateMentorStatus(params);
                      }}
                    >
                      ACCEPT
                      <span
                        className="tooltiptext tooltip-bottom "
                        style={{
                          left: "2rem",
                          top: "3rem",
                          width: "150px",
                        }}
                      >
                        Accept Application
                      </span>
                    </div>
                    <div
                      className="d-flex newAboutExitBtn7 newuserTooltip"
                      onClick={() => {
                        handleDelete(item);
                      }}
                    >
                      DECLINE
                      <span
                        className="tooltiptext tooltip-bottom "
                        style={{
                          left: "2rem",
                          top: "3rem",
                          width: "150px",
                        }}
                      >
                        Decline Application
                      </span>
                    </div>
                  </div>
                )}
                {item?.requestStatus == "Declined" && cohortAdminBoolean && (parentData?.cohort?.cohortStatus !== undefined && parentData?.cohort?.cohortStatus !== "CLOSED" ) && (
                  <div
                    className="d-flex footerCohortV26"
                    style={{
                      justifyContent: "left",
                      width: "100%",
                      marginLeft: "1.2rem",
                    }}
                  >
                    <div
                      className="d-flex newAboutExitBtn61 newuserTooltip"
                      onClick={() => {
                        let params = {
                          id: item.id,
                          requestStatus: "Accepted",
                          updatedBy: value.id,
                        };
                        updateMentorStatus(params);
                      }}
                    >
                      ACCEPT
                      <span
                        className="tooltiptext tooltip-bottom "
                        style={{
                          left: "2rem",
                          top: "3rem",
                          width: "150px",
                        }}
                      >
                        Accept Application
                      </span>
                    </div>
                  </div>
                )}
                {cohortAdminBoolean  &&  item?.mentor?.id !== loginData?.id   ? (
                  <div
                    className="d-flex footerCohortV2"
                    style={{ justifyContent: "center", width: "100%" }}
                  >
                    {
                      // !item?.cohortApplication?.cohortVisibility &&
                      <div
                      className={
                        item?.requestStatus == "Declined"
                          ? "newAboutExitBtnDisabled3 d-flex newuserTooltip"
                          : item?.requestStatus == "Requested"
                          ? "newAboutExitBtn5 d-flex newuserTooltip"
                          : item?.requestStatus == "Request Sent"
                          ? "d-flex  newAboutExitBtnDisabled3 newuserTooltip"
                          : "d-flex newAboutExitBtn3 newuserTooltip"
                      }
                      onClick={() => {
                        if (item?.requestStatus == "Accepted") {
                          setChatBoxModalOpen(true);
                          setMentorID(item?.mentor);
                        } else if (item?.requestStatus == "Requested") {
                          setModalData(item.requestJson);
                          setIntentData(item.intentToMentor);
                          setModalOpen(true);
                        }
                        // else{
                        //   setModalVisibility(true)
                        //   setMentorID(item?.mentor?.id)
                        // }
                      }}
                    >
                      {" "}
                      {/* {LoginRole == "Mentor" ? "Message" : "Connect"} */}
                      {item?.requestStatus == "Accepted"
                        ? "Send Message"
                        : item?.requestStatus == "Declined"
                        ? "Declined"
                        : item?.requestStatus == "Requested" && 
                          "View Application"}
                      {item?.requestStatus !== "Declined" && (
                        <span
                          className="tooltiptext tooltip-bottom "
                          style={{
                            left: "2rem",
                            top: "3rem",
                            width: "150px",
                          }}
                        >
                          {item?.requestStatus == "Accepted"
                            ? "Send Message"
                            : item?.requestStatus == "Declined"
                            ? "Declined"
                            : item?.requestStatus == "Requested" &&
                              "View Application"}

                          {/* {LoginRole == "Mentor" ? "Send Message" : "Send Request"} */}
                        </span>
                      )}
                    </div>
                    }
                 
                    <div
                      className="d-flex newAboutExitBtn2 newuserTooltip"
                      onClick={() => {
                        ViewProfile(item?.mentor?.email);
                      }}
                    >
                      View Profile{" "}
                      <span
                        className="tooltiptext tooltip-bottom "
                        style={{
                          left: "2rem",
                          top: "3rem",
                          width: "150px",
                        }}
                      >
                        View Mentor Profile
                      </span>
                    </div>
                  </div>
                ) :   item?.mentor?.id !== loginData?.id && (
                  <div
                    className="d-flex footerCohortV2"
                    style={{ justifyContent: "center", width: "100%" }}
                  >
                    <div
                      className={
                        item?.mentor?.requestSent == false
                          ? "d-flex newAboutExitBtn2 newuserTooltip"
                          : item?.mentor?.requestStatus == "Declined"
                          ? "newAboutExitBtnDisabled3 d-flex newuserTooltip"
                          : item?.mentor?.requestStatus == "Received Request"
                          ? "newAboutExitBtnDisabled3 d-flex newuserTooltip"
                          : item?.mentor?.requestStatus == "Request Sent"
                          ? "d-flex  newAboutExitBtnDisabled3 newuserTooltip"
                          : "d-flex newAboutExitBtn3 newuserTooltip"
                      }
                      onClick={() => {
                        if(LoginRole == "Admin" || LoginRole == "Mentor"){
                          setChatBoxModalOpen(true);
                          setMentorID(item?.mentor);
                        }
                      else {
                          if (!item?.mentor?.requestSent) {
                            setModalVisibility(true);
                            setMentorID(item?.mentor?.id);
                          } else if (
                            item?.mentor?.requestStatus == "Declined" ||
                            item?.mentor?.requestStatus == "Received Request" ||
                            item?.mentor?.requestStatus ==
                              "Request Sent"
                          ) 
                          {
                            setModalOpen2(true);
                            setModalData(item?.mentor?.mentorRequest?.requestJson)
                          } 
                          else if (
                            item?.mentor?.requestStatus == "Ongoing Mentorship"
                          ) {
                            setChatBoxModalOpen(true);
                            setMentorID(item?.mentor);
                          }
                         
                        }
                      }}
                    >
                      {" "}
                      {/* {LoginRole == "Mentor" ? "Message" : "Connect"} */}
                      {/* {(LoginRole == "Mentor" ||
                      item?.mentor?.requestStatus == "Ongoing Mentorship")
                        ? "Send Message"
                        : item?.mentor?.requestStatus ==
                          "Declined"
                        ? "Declined"
                        : item?.mentor?.requestStatus ==
                          "Received Request"
                        ? "Request Sent"
                        : "Connect"} */}
                      {
                       LoginRole == "Admin" ?
                       "Send Message" :
                      LoginRole == "Mentor" ||
                      item?.mentor?.requestStatus == "Ongoing Mentorship"
                        ? "Message"
                        : item?.mentor?.requestSent == false
                        ? "Send Application"
                        : item?.mentor?.requestStatus == "Declined"
                        ? "Declined"
                        : (item?.mentor?.requestStatus == "Request Sent" ||
                            item?.mentor?.requestStatus ==
                              "Received Request") &&
                          "Request Sent"}
                   
                          <span
                            className="tooltiptext tooltip-bottom "
                            style={{
                              left: "2rem",
                              top: "3rem",
                              width: "150px",
                            }}
                          >
                           {
                             LoginRole == "Admin" ?
                             "Send Message" :
                           LoginRole == "Mentor" ||
                      item?.mentor?.requestStatus == "Ongoing Mentorship"
                        ? "Message"
                        : item?.mentor?.requestSent == false
                        ? "Send Application"
                        : item?.mentor?.requestStatus == "Declined"
                        ? "View Application"
                        : (item?.mentor?.requestStatus == "Request Sent" ||
                            item?.mentor?.requestStatus ==
                              "Received Request") &&
                          "View Application"}

                            {/* {LoginRole == "Mentor" ? "Send Message" : "Send Request"} */}
                          </span>
                        
                    </div>
                    <div
                      className="d-flex newAboutExitBtn2 newuserTooltip"
                      onClick={() => {
                        ViewProfile(item?.mentor?.email);
                      }}
                    >
                      View Profile{" "}
                      <span
                        className="tooltiptext tooltip-bottom "
                        style={{
                          left: "2rem",
                          top: "3rem",
                          width: "150px",
                        }}
                      >
                        View Mentor Profile
                      </span>
                    </div>
                  </div>
                )}
                {/* <div
                className="d-flex footerCohortV2"
                style={{ justifyContent: "center",width:"100%"}}
              >
                <div className={item?.mentor?.requestStatus == "Declined" ? "newAboutExitBtnDisabled3 d-flex newuserTooltip" :  item?.mentor?.requestStatus ==  "Request Sent" ? "d-flex  newAboutExitBtnDisabled4 newuserTooltip" : "d-flex newAboutExitBtn3 newuserTooltip" } 
                onClick={()=>{
                  if(LoginRole == "Mentor")
                  {
                    setChatBoxModalOpen(true);
                    setMentorID(item?.mentor)
                  }
                  else{
                    setModalVisibility(true)
                    setMentorID(item?.mentor?.id)
                  }
                }}>
                
                  {(LoginRole == "Mentor" || returnTextStatus(item?.mentor?.requestStatus) == "Message") ? "Message" : returnTextStatus(item?.mentor?.requestStatus) == "Declined" ? "Declined" :  returnTextStatus(item?.mentor?.requestStatus) == "Sent" ? "Request Sent" :   "Connect"}
                  {
                  item?.mentor?.requestStatus !== "Declined" && item?.mentor?.requestStatus !==  "Request Sent" &&
                  <span
                    className="tooltiptext tooltip-bottom "
                    style={{
                      left: "2rem",
                      top: "3rem",
                      width: "150px",
                    }}
                  >
                                                        {(LoginRole == "Mentor" || returnTextStatus(item?.mentor?.requestStatus) == "Message") ? "Send Message" :  "Send Application"}

                    
                  </span>
        }
                </div>
                <div className="d-flex newAboutExitBtn2 newuserTooltip"  onClick={()=>{
                        ViewProfile(item?.mentor?.email)
                      }}>
                  View Profile{" "}
                  <span
                    className="tooltiptext tooltip-bottom "
                    style={{
                      left: "2rem",
                      top: "3rem",
                      width: "150px",
                    }}
                  >
                    View Mentor Profile
                  </span>
                </div>
              </div> */}
              </Paper>
            );
          })
        ) : (
          <div className="emptyListCohort">No records found</div>
        )}
      </div>
      <div className="pagination-box mt-2">
        {getTotalMentorsPaginate !== undefined && (
          <Pagination
            activePage={activePage}
            itemsCountPerPage={12}
            totalItemsCount={getTotalMentorsPaginate?.totalElements}
            pageRangeDisplayed={5}
            onChange={handlePageChange.bind(this)}
          />
        )}
      </div>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    getTotalMentorsData: state.MentorReducer.getCohortMentorModuleList.data,
    getTotalMentorsPaginate:
      state.MentorReducer.getCohortMentorModuleList.paginate,
    mentorApplicationList:
      state.AdminMentorReducer.getAdminMentorApplicationList.data,
    totalMentors: state.AdminMentorReducer.getAdminMentorApplicationList,
    mentorApplicationListPaginatine:
      state.AdminMentorReducer.getAdminMentorApplicationList.paginate,
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    getCounter: state.AdminMentorReducer.getCountersList.data,
    updatedStatus: state.AdminMentorViewReducer.updateApplicationStatus.data,
    getNamesListData: state.AdminMentorReducer.getNamesList?.data,
    getStepperData: state.AdminMentorReducer.getStepperList.list,
    getExcelMentorData: state.AdminMentorReducer.getExcelMentor,
    mentorCounter:state.MentorReducer.cohortDashboardMentorCounter.data,
  };
};

export default connect(mapStateToProps, {
  getAdminMentorApplicationList,
  getPredefineOptionsList,
  postMentorModuleCohort,
  postCohortMentorListCounter,
})(withRouter(MentorPage));
